module.exports = __webpack_public_path__ + "static/img/11.d4dce4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/11.png
// module id = +hVg
// module chunks = 1